import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { ReqnoService } from '../../../service/reqno/reqno.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { CarrierService } from '../../../service/carrier/carrier.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9222',
  templateUrl: 'wa9222.component.html',
  styleUrls: ['wa9222.component.scss']
})
export class Wa9222Component implements OnInit {
  public componentTitle = 'WA9222:問合せ番号マスタ登録';

  // selected owner info
  public ownerResult: any;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // drop down list
  public owners: any;
  public carriers: any;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public ownerTx = new FormControl();
  public ownerId = new FormControl('', [Validators.required]);
  public reqmngCd = new FormControl('', [Validators.maxLength(validation.reqmngCd.maxLength)]);
  public carrierCd = new FormControl('', [Validators.required]);
  public startreqnoNr = new FormControl(0, [Validators.pattern(validation.integer), Validators.max(validation.startreqnoNr.maxNr), Validators.min(validation.startreqnoNr.minNr)]);
  public endreqnoNr = new FormControl(0, [Validators.pattern(validation.integer), Validators.max(validation.endreqnoNr.maxNr), Validators.min(validation.endreqnoNr.minNr)]);
  public orderNr = new FormControl(1, [Validators.pattern(validation.integer), Validators.max(validation.reqnoorderNr.maxNr), Validators.min(validation.reqnoorderNr.minNr)]);
  // build FormGroup
  myForm = this.builder.group({
    ownerId: this.ownerId,
    carrierCd: this.carrierCd,
    startreqnoNr: this.startreqnoNr,
    endreqnoNr: this.endreqnoNr,
    orderNr: this.orderNr
  });
  private errorInfo = '';

  private ownerIdCls = '';
  private reqmngCdCls = '';
  private carrierCdCls = '';
  private startreqnoNrCls = '';
  private endreqnoNrCls = '';
  private orderNrCls = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  private selectedOwnerId = null;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private reqnoService: ReqnoService,
    private ownerService: OwnerService,
    private carrierService: CarrierService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    // drop down list
    this.ownerService
      .get()
      .then(outputJson => {
        console.log(outputJson);
        this.owners = outputJson.owners;
        this.ownerResult = sessionStorage.getItem('ownerResult');
        if (this.ownerResult !== null) {
          const selectedOwner = JSON.parse(this.ownerResult);
          this.ownerId.setValue(selectedOwner.ownerId);
          this.ownerTx.setValue(selectedOwner.ownerTx);
        }
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.carrierService
      .get()
      .then(__outputJson => {
        console.log(__outputJson);
        this.carriers = __outputJson.carriers;
        // On Ver1.1, only 1002 is valid
        this.carrierCd.setValue('1002');
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isSubmitButtonEnabled) return;

    let errors = false;
    if (this.startreqnoNr.errors !== null) {
      this.startreqnoNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.endreqnoNr.errors !== null) {
      this.endreqnoNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.orderNr.errors !== null) {
      this.orderNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    let reqmngCd = this.reqmngCd.value;
    if (this.reqmngCd.value === null || this.reqmngCd.value === '') {
      reqmngCd = this.carrierCd.value;
    }
    this.reqnoService
      .post(this.ownerId.value, reqmngCd, this.carrierCd.value, this.startreqnoNr.value, this.endreqnoNr.value, this.orderNr.value, 'wa9222')
      .then(outputJson => {
        this.working = false;
        // sessionStorage.setItem('SuccessInfoMessage', '完了,登録が完了しました');
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';

    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    } else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    this.ownerTx.setValue('');
    this.ownerId.setValue('');
    this.reqmngCd.setValue('');
    this.startreqnoNr.setValue('');
    this.endreqnoNr.setValue('');
    this.orderNr.setValue('');
    this.carrierCd.setValue('');
    this.isSubmitButtonEnabled = false;

    this.ownerResult = sessionStorage.getItem('ownerResult');
    this.selectedOwnerId = null;
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.selectedOwnerId = selectedOwner.ownerId === undefined ? null : selectedOwner.ownerId;
      this.ownerId.setValue(selectedOwner.ownerId === undefined ? '' : selectedOwner.ownerId);
      this.ownerTx.setValue(selectedOwner.ownerTx === undefined ? '' : selectedOwner.ownerTx);
    }
  }

  ngDoCheck() {
    if (!this.isShow) return;

    if (this.ownerResult == null) {
      this.ownerIdCls = this.ownerId.value === '' ? '' : this.ownerId.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    } else {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerIdCls =
        selectedOwner.ownerId === undefined
          ? this.ownerId.value === undefined || this.ownerId.value + '' === ''
            ? ''
            : 'active'
          : this.ownerId.value == selectedOwner.ownerId
            ? 'normal'
            : this.ownerId.value === undefined || this.ownerId.value + '' === ''
              ? ''
              : 'active';
    }
    // this.ownerIdCls = this.ownerResult == null ? this.ownerId.value === '' ? '' : (this.ownerId.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR) : ;
    this.reqmngCdCls = this.reqmngCd.value === '' ? '' : this.reqmngCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.carrierCdCls = this.carrierCd.value === '' ? '' : this.carrierCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.startreqnoNrCls = this.startreqnoNr.value + '' === '' ? '' : this.startreqnoNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.endreqnoNrCls = this.endreqnoNr.value + '' === '' ? '' : this.endreqnoNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.orderNrCls = this.orderNr.errors == null ? (this.orderNr.value != null && (this.orderNr.value + '').length > 0 ? this.STRINGS_ACTIVE : '') : this.STRINGS_ERROR;
    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    this.isSubmitButtonEnabled =
      (this.ownerIdCls === this.STRINGS_ACTIVE || this.ownerIdCls === 'normal') &&
      this.reqmngCdCls !== this.STRINGS_ERROR &&
      (this.carrierCdCls === this.STRINGS_ACTIVE || this.carrierCdCls === 'normal') &&
      this.orderNrCls === this.STRINGS_ACTIVE &&
      this.startreqnoNrCls === this.STRINGS_ACTIVE &&
      this.endreqnoNrCls === this.STRINGS_ACTIVE;
  }

  clrErr() {

    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9222/wa9222.component.ts